export function normalizeTextFromDifferentFormatation(input: string): string {
  if (!input) return '';
  const invisibleChars = /[\u200E\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/g;
  const normalizedHyphens = input.replace(/[\u2010\u2011\u2012\u2013\u2014\u2212]/g, '-');
  const cleaned = normalizedHyphens.replace(invisibleChars, '');
  return cleaned;
}

export function normalizeTextSearch(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function normalizeLowerCase(text: string): string {
  return normalizeTextSearch(text).toLowerCase();
}
